module.exports = __webpack_public_path__ + "static/media/cover_page_t1.ff438235.png";